export default __webpack_public_path__ + "static/media/J724_21A724D.c3ea03b3.STEP";